import { createSelector } from 'reselect'
import { State } from 'index'

const errorSelector = (state: State) => state.error

export const getConfirmPasswordError = createSelector([errorSelector], (state) => state.confirm_password)
export const getEmailError = createSelector([errorSelector], (state) => state.email)
export const getPasswordError = createSelector([errorSelector], (state) => state.password)
export const getStripeError = createSelector([errorSelector], (state) => state.stripe)
